import { createFileRoute } from "@tanstack/react-router";
import { PublicRoundsScreen } from "@modules/rounds/views";

// /website — the public intake-round catalogue, standing in for the real public site until the
// client's own team ships it (see apps/website/README.md).
//
// The ONLY route in the app with no `beforeLoad`. Every other route either proves a group
// (/staff, /applicant) or rehydrates and redirects (/) — this one must do neither: it reads the
// one unauthenticated endpoint in the API, so a guard would be the bug. It deliberately does NOT
// bounce a signed-in visitor to their workspace the way "/" does either; the page a staff member
// wants to check is the one the public will see.
//
// No `staticData.breadcrumb`: that is app-shell furniture, and this screen renders outside it.
export const Route = createFileRoute("/website")({
  component: PublicRoundsScreen,
});
